"use client";
import { Link } from 'react-router-dom';
export default function Home() {
  


  return (
    <>
      
        {/*Blog Details Start*/}
        <section className="event-details">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12">
                <div className="event-details__left">
                  
                  <div className="event-details__main-tab-box tabs-box">
                   
                    <div className="tabs-content">
                      
                        <div>
                         <div className="event-details__tab-content-box">
                           
                            <h3 className="event-details__title-1 text-center">
                                Terms and Policies Page
                            </h3>
                            <br/>
                            <h4>RSVPPASS Terms and Policies</h4>
                            <p className="event-details__text-1">
                                Understand the rules for using RSVPPASS, your trusted event discovery platform.
                            </p>
                              <div className="event-details__points-box">
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>Terms of Use</strong></p>
                                </div>
                                <p className="event-details__text-1">
                                By using RSVPPASS, you agree to these terms, ensuring a fair and secure experience.
                            </p>
                           
                            <div className="event-details__points-box">
                                <ul className="event-details__points list-unstyled">
                                <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>**Eligibility**</strong>: Must be 18+ to use our services.</p>
                                </li>
                                <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>**Account Security**</strong>: Protect your credentials; unauthorized access is prohibited.</p>
                                </li>
                                 <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>**Compliance**</strong>: Use our platform lawfully.</p>
                                </li>
                                </ul>
                                
                            </div>
                            <br></br>
                             <div className="event-details__points-box">
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>Event Listings and Tickets</strong></p>
                                </div>
                                <p className="event-details__text-1">
                                We connect you to events but are not liable for:
                            </p>
                             
                            <div className="event-details__points-box">
                                <ul className="event-details__points list-unstyled">
                                <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p>Cancellations or changes.</p>
                                </li>
                                <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p>Third-party event information accuracy.</p>
                                </li>
                                 <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p>Refunds, handled by organizers or ticketing platforms.</p>
                                </li>
                                </ul>
                                
                            </div>

                            <br></br>
                             <div className="event-details__points-box">
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>Privacy Policy</strong></p>
                                </div>
                                <p className="event-details__text-1">
                                Your data is safe with us:
                            </p>
                             
                            <div className="event-details__points-box">
                                <ul className="event-details__points list-unstyled">
                                <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>**Collection**</strong>: Name, email, etc., for personalized experiences.</p>
                                </li>
                                <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>**Use**</strong>: Event promotion and analytics for 1M+ contacts.</p>
                                </li>
                                 <li>
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>**Protection**</strong>: No data sales without consent.</p>
                                </li>
                                </ul>
                                
                            </div>

                            <p className="event-details__text-1">Contact: privacy@rsvppass.com</p>
                            </div>
                        </div>

                          <br></br>
                             <div className="event-details__points-box">
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>Intellectual Property</strong></p>
                                </div>
                                <p className="event-details__text-1">
                                RSVPPASS content (logos, text) is protected. Reproduction requires permission.
                                </p>
                            
                        <br></br>
                             <div className="event-details__points-box">
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>Limitation of Liability</strong></p>
                                </div>
                                <p className="event-details__text-1">
                                We’re not responsible for damages from platform use or event issues.
                                </p>

                            <br></br>
                             <div className="event-details__points-box">
                                    <div className="icon">
                                    <span className="icon-double-angle"></span>
                                    </div>
                                    <p><strong>Changes to Terms</strong></p>
                                </div>
                                <p className="event-details__text-1">
                                Terms may update; continued use implies acceptance.
                                </p>

                        <br></br>
                             <div className="event-details__points-box">
                                    
                                    <p><strong>Questions about our terms?</strong></p>
                                </div>
                                <p className="event-details__text-1">
                                Reach out for clarity on our policies. <Link to="/contact">Contact Us.</Link>
                                </p>
                      
                    </div>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </section>
        {/*Blog Details End*/}
    </>
  );
}
